import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import { formatters } from '../../../utils'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const renderValue = (value, { withCents = false, defaultVal }) => {
  return withCents
    ? formatters.formatMoneyWithCents(value, defaultVal)
    : formatters.formatMoney(value, defaultVal)
}

const CurrencyCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]
  const fieldValue = _.get(row, field)
  const value = fieldValue || (fieldValue === 0 ? fieldValue : row[baseField])
  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(value, definition.formatOptions || {})}
      </div>
    </Cell>
  )
}

/**
 * formatOptions for CurrencyCell allow for withCents format along with an optional default value.
 * e.g. formatOptions: {
 *  withCents: true,
 *  defaultVal: '0',
 * }
 */

CurrencyCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formatOptions: PropTypes.shape({
      withCents: PropTypes.bool,
      defaultVal: PropTypes.string,
    }),
  }).isRequired,
  data: PropTypes.array,
}

export default CurrencyCell
